const get = require('just-safe-get');

module.exports = {
  onInput: input => Object.assign({
    sid: get(input.model, ['action', 'trackingList', 0, 'eventProperty', 'sid']),
  },
  input,
  typeof (input.model) === 'string' ? { text: input.model } : input.model),

  clickHandler(event) {
    if (this.input.sid && window.triggerTracking && this.input.action.type === 'OPERATION') {
      window.triggerTracking('pulsar', this.input.action.trackingList);
    }

    this.emit('click', this.input, event, event.target);
  },
};
